<template>
  <v-row
    align="center"
    justify="center"
    class="mt-8 glossary__choices mb-8 pa-2"
  >
    <v-col cols="12" md="3">
      <div class="input__wrapper">
        <search
          :searchText="searchText"
          placeholder="Search"
          :totalResult="mx$glossaryLength"
          :isLoading="glossaryLoading"
          @search="handleSearch"
        />
      </div>
    </v-col>
    <v-col cols="12" md="9" class="pa-0">
      <ul class="alphanumeric pl-0">
        <li
          class="alphanumeric-all"
          @click="handleSearch('', true)"
        >
          All
        </li>
        <li
          v-for="letter in letters"
          v-bind:key="letter"
          :class="{
            active:
              String(letter).toLocaleLowerCase() === glossarySearch &&
              glossarySearchIsLetter,
          }"
          @click="handleSelectLetter(letter)"
        >
          {{ letter }}
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
import Search from '../../components/inputs/search.vue';
import { GLOSSARY_OPTIONS, SEGMENT_EVENTS } from '../../constants';
import GlossaryMixin from '../../mixins/glossary.mixin';

export default {
  mixins: [GlossaryMixin],
  components: {
    Search,
  },
  data: () => ({
    letters: GLOSSARY_OPTIONS,
    searchText: '',
  }),
  watch: {
    '$route.query'() {
      this.fetchGlossary();
    },
  },
  mounted() {
    this.fetchGlossary();
  },
  methods: {
    fetchGlossary() {
      const query = this.$route.query;
      if (query && !query.option && query.search) {
        this.searchText = query.search;
      }
      this.setGlossarySearch(query && query.search ? query.search : '');
      this.setGlossarySearchIsLetter(Boolean(query?.option));
      this.mx$fetchGlossaries();
    },
    handleSearch(value, isAll = false) {
      this.searchText = value;
      if (!this.glossarySearchIsLetter && this.glossarySearch === value) {
        return;
      }
      if (isAll) {
        window.analytics.track(SEGMENT_EVENTS.SEARCH_GLOSSARY_BY_LETTER, {
          letter: 'all',
          contentType: 'Glossary',
        });
      } else {
        window.analytics.track(SEGMENT_EVENTS.SEARCH_GLOSSARY, {
          searchTerm: String(value).toLocaleLowerCase(),
          contentType: 'Glossary',
        });
      }
      this.setGlossarySearch(value);
      this.setGlossarySearchIsLetter(false);
      this.$router.replace({
        name: 'Glossary',
        query: {
          search: value ? value : undefined,
        },
      });
    },
    handleSelectLetter(value) {
      this.searchText = '';
      const letter = String(value).toLocaleLowerCase();
      if (this.glossarySearchIsLetter && this.glossarySearch === letter) {
        return;
      }
      window.analytics.track(SEGMENT_EVENTS.SEARCH_GLOSSARY_BY_LETTER, {
        letter: String(value).toLocaleLowerCase(),
        contentType: 'Glossary',
      });
      this.setGlossarySearch(letter);
      this.setGlossarySearchIsLetter(true);
      this.$router.replace({
        name: 'Glossary',
        query: {
          search: letter ? letter : undefined,
          option: letter ? 1 : undefined,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.glossary__choices {
  background-color: #fff;
  box-shadow: 0px 0.375rem 1.125rem rgba(0, 0, 0, 0.06);
  border-radius: 0.25rem;
  margin: -0.0625rem;
}
.input__wrapper {
  height: 4.125rem;
  padding-top: 0.3125rem;
}
ul.alphanumeric {
  list-style: none;
}
ul.alphanumeric li {
  float: left;
  font-style: normal;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.5rem;
  text-align: center;
  letter-spacing: 0.0063rem;
  text-transform: capitalize;
  color: var(--v-primary-base);
  border-right: 0.0625rem solid #ccd3de;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #424540bd;
    cursor: pointer;
  }
  &.active {
    color: #424540bd;
    cursor: default;
  }
  &.alphanumeric-all {
    color: #FF6B00;
  }
}
ul.alphanumeric li:last-child {
  border: 0;
}
</style>
